import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2452_13999",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 33,
		height: 32,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			width: 32,
			height: 32,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2452_13999)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.2694 12.077V10.077H27.8334V12.077H10.2694ZM10.2694 17V15H27.8334V17H10.2694ZM10.2694 21.923V19.923H27.8334V21.923H10.2694ZM6.24369 12.154C5.93858 12.154 5.6828 12.0496 5.47635 11.8407C5.26991 11.6318 5.16669 11.3729 5.16669 11.064C5.16669 10.7627 5.26991 10.51 5.47635 10.306C5.6828 10.102 5.93858 10 6.24369 10C6.5488 10 6.80458 10.102 7.01102 10.306C7.21746 10.51 7.32069 10.7627 7.32069 11.064C7.32069 11.3729 7.21746 11.6318 7.01102 11.8407C6.80458 12.0496 6.5488 12.154 6.24369 12.154ZM6.24369 17.064C5.93858 17.064 5.6828 16.962 5.47635 16.758C5.26991 16.5542 5.16669 16.3016 5.16669 16C5.16669 15.682 5.26991 15.4209 5.47635 15.2167C5.6828 15.0124 5.93858 14.9103 6.24369 14.9103C6.5488 14.9103 6.80458 15.0124 7.01102 15.2167C7.21746 15.4209 7.32069 15.682 7.32069 16C7.32069 16.3016 7.21746 16.5542 7.01102 16.758C6.80458 16.962 6.5488 17.064 6.24369 17.064ZM6.24369 22C5.93858 22 5.6828 21.8956 5.47635 21.6867C5.26991 21.4778 5.16669 21.219 5.16669 20.9103C5.16669 20.6088 5.26991 20.356 5.47635 20.152C5.6828 19.948 5.93858 19.846 6.24369 19.846C6.5488 19.846 6.80458 19.948 7.01102 20.152C7.21746 20.356 7.32069 20.6088 7.32069 20.9103C7.32069 21.219 7.21746 21.4778 7.01102 21.6867C6.80458 21.8956 6.5488 22 6.24369 22Z",
			fill: "#D0DFE4"
		})
	})]
});
export default SvgListMobile;
